/**
 * This is the i18n configuration
 * 
 * See https://www.i18next.com/configuration-options.html
 */
module.exports = { backend: { loadPath: 'api/public/getLocales?lang={{lng}}'}} ;